<template>
  <v-tooltip bottom>
    <span slot="activator" :style="{color: styleColor}">
      {{ shotName }}
    </span>
    <span>
    {{shotName}} <!-- todo(egor): add description -->
    </span>
  </v-tooltip>
</template>

<script>
    import {getEventColor} from  './caseServiceLogUtils'
    const skipPrefixLength = "Change".length;

    export default {
        name: 'case-service-log-event',
        components: {},
        props: {
            event: {
                type: String,
                required: true
            }
        },
        data() {
            return {}
        },
        computed: {
            shotName() {
                return this.event.substring(skipPrefixLength, this.event.length)
            },
            firstLetter() {
                return this.shotName[0]
            },
            styleName() {
                return this.shotName.toLowerCase()
            },
            styleColor() {
                return getEventColor(this.event)
            }
        },
        mounted() {
        },
        methods: {}
    }
</script>

<style scoped>
  .requested {
    color: orange;
  }

  .executed {
    color: green
  }

  .checked {
    color: violet;
  }

  .charged {
    color: red
  }

  .paid {
    color: blue;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sales/case/CaseServiceLogEvent.vue